<template lang="html">
  <div class="">
    <search-form :ruleForm="ruleForm" @search="search" />
    <order-table ref="orderTable" :ruleForm="ruleForm" />
  </div>
</template>

<script>
import searchForm from "./components/searchForm";
import orderTable from "./components/orderTable";
export default {
  data() {
    return {
      ruleForm: {
        orderNo: "",
        createTime: [],
        totalWeightRange: {
          type: 0,
          start: "",
          end: ""
        },
        orderType: 1,
        startPoint: '',
        endPoint: '',
        activeName: "0"
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    search() {
      this.$refs.orderTable.getDataList(true);
    }
  },
  watch: {},
  components: {
    searchForm,
    orderTable
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/order/index.vue